import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message

import UIAdminOnlyWrapper from 'ui-addon-upgrades/decorators/UIAdminOnlyWrapper';
import { REQUEST_QUOTE } from 'ui-addon-upgrades/_core/common/constants/AdminModalTypes';
import { BILLING } from 'ui-addon-upgrades/_core/common/constants/AdminTypes';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButton from 'UIComponents/button/UIButton';
import { fetchActiveQuotes } from 'pricing-pages-ui/api/QuotesApi';
import { getActiveQuoteUrl, handleRedirect } from 'pricing-pages-lib/utils/urls';
import { allProductVersionsSelector, productSelector } from '../../selectors/ProductsSelectors';
import { getRelevantQuote } from 'pricing-pages-ui/utils/getRelevantQuote';
import { APP } from 'pricing-pages-ui/constants/AuthType';
import ProductLineMap from 'self-service-api/constants/ProductLineMap';

const ActiveQuoteBanner = ({
  productLine,
  screen,
  // for unit testing purposes
  __defaultIsVisible = false
}) => {
  const [activeQuotes, setActiveQuotes] = useState([]);
  const [visible, setVisible] = useState(__defaultIsVisible);
  const uniqueId = 'active-quote-banner';

  const trackBannerInteraction = name => {
    getUsageTracker().track('bannerInteraction', {
      name
    });
  };

  useEffect(() => {
    let isCancelled = false;
    fetchActiveQuotes().then(data => {
      if (!isCancelled) {
        setActiveQuotes(data);
        setVisible(true);
        trackBannerInteraction('view-active-quote-banner');
      }
    }).catch(error => {
      console.error(error);
      setVisible(false);
    });
    return () => {
      isCancelled = true;
    };
  }, []);

  const handleClickQuote = relevantQuote => {
    trackBannerInteraction('click-active-quote-banner');
    handleRedirect(getActiveQuoteUrl(relevantQuote.publicId));
  };

  const handleDismiss = () => {
    trackBannerInteraction('dismiss-active-quote-banner');
    setVisible(false);
  };

  const allSkuIdsInProductLine = useSelector(state => Object.values(allProductVersionsSelector(state)).filter(({
    productId
  }) => {
    const product = productSelector(state, {
      productId
    });
    return product && product.productLine === productLine;
  }).map(({
    skuId
  }) => skuId));
  if (!visible) return null;
  const relevantQuote = getRelevantQuote(activeQuotes, allSkuIdsInProductLine);
  if (!relevantQuote) return null;
  return /*#__PURE__*/_jsx("div", {
    "data-selenium-id": "active-quote-banner",
    children: /*#__PURE__*/_jsxs(UIAlert, {
      type: "info",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "activeQuote.title"
      }),
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "activeQuote.text"
      }), /*#__PURE__*/_jsx(UIAdminOnlyWrapper, {
        adminType: BILLING,
        modalType: REQUEST_QUOTE,
        productLine: productLine,
        upgradeData: {
          app: APP,
          screen,
          upgradeProduct: ProductLineMap[productLine].upgradeProduct,
          uniqueId
        },
        children: /*#__PURE__*/_jsx(UIButton, {
          className: "m-left-4",
          use: "tertiary",
          size: "small",
          onClick: () => handleClickQuote(relevantQuote),
          "data-selenium-id": "active-quote-purchase-button",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "activeQuote.link"
          })
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        className: "m-left-4",
        use: "tertiary-light",
        size: "small",
        onClick: handleDismiss,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "activeQuote.dismiss"
        })
      })]
    })
  });
};

export default ActiveQuoteBanner;